module.exports = __webpack_public_path__ + "static/marketing-pro-video-thumbnail-788da1b6f68fc92b78fc1ea78e260316.png";